import { FavouritesManagementService } from '@modules/real-property-toolbar/services/favourites-management.service';

export const services = [FavouritesManagementService];

export * from './favourites-management.service';
